import * as React from 'react';
import svg from './xlsx.svg';

function SvgXlsx() {
  return <img src={svg} alt="Excel" />;
}

export default SvgXlsx;
